(() => {
 const ar=document.documentElement.lang?.toLowerCase().startsWith('ar');
 const colorMap={black:'أسود',white:'أبيض',pink:'وردي',blue:'أزرق',beige:'بيج',fushia:'فوشيا',fuchsia:'فوشيا',green:'أخضر',red:'أحمر',camel:'جملي','baby blue':'لبني'};
 const productRoot=()=>document.querySelector('[id^="MainProduct-"] .product')||document.querySelector('.product.product--large');
 function localizePolicyLinks(root=document){
  root.querySelectorAll('a[href*="/policies/"]').forEach(link=>{
   try{
    const url=new URL(link.getAttribute('href'),window.location.origin);
    url.searchParams.set('locale',ar?'ar':'en');
    link.href=url.toString();
   }catch(e){}
  });
 }
 function enhance(root=document){
  localizePolicyLinks(root);
  const p=productRoot(); if(p)p.classList.add('tl-product-page');
  root.querySelectorAll('.product-form__input').forEach(fieldset=>{
   const legend=(fieldset.querySelector('.form__label')?.textContent||'').trim().toLowerCase();
   if(legend.includes('size')||legend.includes('مقاس'))fieldset.classList.add('tl-size-options');
   if(ar&&(legend.includes('color')||legend.includes('colour')||legend.includes('لون'))){
    fieldset.querySelectorAll('label').forEach(label=>{
     const input=document.getElementById(label.getAttribute('for')); const raw=(input?.value||'').trim(); const translated=colorMap[raw.toLowerCase()];
     if(translated){for(const node of label.childNodes){if(node.nodeType===Node.TEXT_NODE&&node.textContent.trim()){node.textContent=node.textContent.replace(raw,translated);break;}}}
    });
    fieldset.querySelectorAll('[data-selected-value]').forEach(el=>{const raw=el.textContent.trim();if(colorMap[raw.toLowerCase()])el.textContent=colorMap[raw.toLowerCase()];});
   }
  });
 }
 function setupPurchaseRow(){
  const qty=document.querySelector('.product__info-container .product-form__quantity');
  const form=document.querySelector('.product__info-container product-form');
  if(!qty||!form||qty.closest('.tl-purchase-row'))return;
  const row=document.createElement('div'); row.className='tl-purchase-row';
  qty.parentNode.insertBefore(row,qty); row.append(qty,form);
 }
 // The sticky action only submits after the visitor explicitly chooses each variant option.
 // The theme may precheck its first variant, so checked inputs alone do not prove user intent.
 function optionGroups(){
  return Array.from(document.querySelectorAll('.product__info-container variant-selects .product-form__input'));
 }
 function optionValue(group){
  return group.querySelector('input[type="radio"]:checked')?.value ||
   group.querySelector('select')?.value || '';
 }
 function setupSticky(){
  const bar=document.querySelector('[data-tl-sticky-add]');
  const mainButton=document.querySelector('.product__info-container .product-form__submit');
  if(!bar||!mainButton||bar.dataset.tlStickyReady==='true')return;
  bar.dataset.tlStickyReady='true';
  bar.hidden=false;
  const stickyButton=bar.querySelector('.tl-sticky-add__button');
  const stickyPrice=bar.querySelector('[data-tl-sticky-price]');
  const selection=bar.querySelector('[data-tl-sticky-selection]');
  if(!stickyButton)return;
  const touched=new Set();
  // A direct product URL with an explicit variant already represents a choice.
  const initiallyLinkedVariant=new URLSearchParams(window.location.search).has('variant');
  const purchaseArea=document.querySelector('.product__info-container');
  const complete=()=>{
   const groups=optionGroups();
   return groups.length===0||groups.every((group,index)=>
    (initiallyLinkedVariant||touched.has(index))&&Boolean(optionValue(group)));
  };
  const sync=()=>{
   const ready=complete();
   stickyButton.disabled=ready&&(mainButton.disabled||mainButton.getAttribute('aria-disabled')==='true');
   const price=document.querySelector('.product__info-container .price .price-item--sale, .product__info-container .price .price-item--regular');
   if(stickyPrice&&price)stickyPrice.textContent=price.textContent.trim();
   if(selection){
    const text=ready?optionGroups().map(optionValue).filter(Boolean).join(' / '):'';
    if(selection.textContent!==text)selection.textContent=text;
    selection.hidden=!text;
   }
  };
  const noteChoice=(event)=>{
   const target=event.target;
   if(!(target instanceof Element))return;
   const choice=target.closest('input[type="radio"],label[for],select');
   const group=choice?.closest('.product-form__input');
   if(!group||!group.closest('variant-selects'))return;
   const index=optionGroups().indexOf(group);
   if(index>=0)touched.add(index);
   sync();
  };
  purchaseArea?.addEventListener('click',noteChoice);
  purchaseArea?.addEventListener('change',event=>{noteChoice(event);setTimeout(sync,75)});
  stickyButton.addEventListener('click',()=>{
   const groups=optionGroups();
   const missing=groups.find((group,index)=>
    (!initiallyLinkedVariant&&!touched.has(index))||!optionValue(group));
   if(missing){
    const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    missing.scrollIntoView({behavior:reduceMotion?'auto':'smooth',block:'center'});
    const heading=missing.querySelector('.form__label');
    if(heading){
     heading.setAttribute('tabindex','-1');
     heading.focus({preventScroll:true});
    }
    return;
   }
   if(!mainButton.disabled&&mainButton.getAttribute('aria-disabled')!=='true')mainButton.click();
  });
  if(purchaseArea)new MutationObserver(sync).observe(purchaseArea,{attributes:true,childList:true,subtree:true});
  sync();
  if('IntersectionObserver'in window){
   new IntersectionObserver(entries=>bar.classList.toggle('is-visible',!entries[0].isIntersecting),{threshold:.1}).observe(mainButton);
  }
 }
 document.addEventListener('DOMContentLoaded',()=>{enhance();setupPurchaseRow();setupSticky();});
 document.addEventListener('shopify:section:load',e=>{enhance(e.target);setupPurchaseRow();setupSticky();});
 new MutationObserver(ms=>{for(const m of ms)for(const n of m.addedNodes)if(n.nodeType===1)enhance(n);}).observe(document.documentElement,{childList:true,subtree:true});
})();